import { Icon } from '@branch-messenger/willow-ui'
import { InfoCircle, LinkExternal01 } from '@branch-messenger/willow-ui/icons'

import { Alert, AlertBodyText } from '@/components/alert'
import { useOrg } from '@/selectors/organization'

import { PhoneScreen } from './PhoneScreen'
import {
  PayoutMethodContainer,
  PayoutMethodInfoContainer,
  Separator,
  UpdatePayoutMethodButton,
} from './styles'

export const WalletInfo = () => {
  const {
    data: { orgInfo },
  } = useOrg()

  const handleOpenApp = () => {
    if (orgInfo?.login_deep_link) {
      window.location.href = orgInfo?.login_deep_link
    }
  }

  return (
    <PayoutMethodContainer>
      <PayoutMethodInfoContainer>
        <PhoneScreen />
        <Separator />
        {orgInfo?.login_deep_link && (
          <UpdatePayoutMethodButton
            onClick={handleOpenApp}
            iconRight={<Icon Icon={LinkExternal01} />}
          >
            {`Open ${orgInfo?.app_display_name} Mobile App`}
          </UpdatePayoutMethodButton>
        )}
      </PayoutMethodInfoContainer>
      <Alert Icon={InfoCircle}>
        <AlertBodyText>
          {`All payouts to your connected ${orgInfo?.app_display_name} account will be sent at`}{' '}
          <AlertBodyText as="span" $bold>
            no cost.
          </AlertBodyText>
        </AlertBodyText>
      </Alert>
    </PayoutMethodContainer>
  )
}
